export default "__VITE_ASSET__BSnA4Gor__"